export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_CHECK = 'AUTH_CHECK';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const SET_TOAST = 'SET_TOAST';
export const ADMIN_AS_CLIENT_LOGIN = 'ADMIN_AS_CLIENT_LOGIN';
export const ADMIN_AS_CLIENT_LOGOUT = 'ADMIN_AS_CLIENT_LOGOUT';
export const SET_ACTIVE_BOT = 'SET_ACTIVE_BOT';
export const SET_LANG = 'SET_LANG';